import React from "react";
import LoaderImg from "../assets/media/loader.gif";
import Styles from "./Loader.module.css";

const Loader = ({ style }) => {
  return <img className={Styles.Loader} style={style} src={LoaderImg} alt="Loader" />;    
};

export default Loader;
